import { BenefitFormData } from '@/types/circuits/CircuitDaysFormData';
import { numberIfNotUndefined } from '@/utils/prices/numberIfNotUndefined';

export const parseCircuitBenefit = (benefit: BenefitFormData) => ({
  ...benefit,
  Pricing: benefit.Pricing.map((pricing) => ({
    ...pricing,
    periods: pricing.periods.map((period) => ({
      ...period,
      startDate: new Date(period.startDate),
      endDate: new Date(period.endDate),
    })),
  })),
  hotel: benefit.hotel
    ? {
        ...benefit.hotel,
        category: benefit.hotel.category ?? undefined,
        pricingType: benefit.hotel.pricingType ?? undefined,
        reducedPriceExists: benefit.hotel.reducedPriceExists ?? undefined,
        isReduction: benefit.hotel.isReduction ?? undefined,
        HotelRoomCategory: benefit.hotel.HotelRoomCategory.map((category) => ({
          ...category,
          pricings: category.pricings.map((pricing) => ({
            ...pricing,
            periods: pricing.periods.map((period) => ({
              ...period,
              startDate: new Date(period.startDate),
              endDate: new Date(period.endDate),
            })),
          })),
        })),
        associatedBenefits: benefit.hotel.associatedBenefits?.map(
          (associatedBenefit) => ({
            ...associatedBenefit,
            benefit: associatedBenefit.benefit
              ? {
                  ...associatedBenefit.benefit,
                  // The API sends null when the supplier has no margin rate,
                  // which the circuit form schema rejects and blocks the save.
                  supplier: associatedBenefit.benefit.supplier
                    ? {
                        ...associatedBenefit.benefit.supplier,
                        marginRate: numberIfNotUndefined(
                          associatedBenefit.benefit.supplier.marginRate,
                        ),
                      }
                    : undefined,
                  Pricing: associatedBenefit.benefit.Pricing?.map(
                    (pricing) => ({
                      ...pricing,
                      periods: pricing.periods.map((period) => ({
                        ...period,
                        startDate: new Date(period.startDate),
                        endDate: new Date(period.endDate),
                      })),
                    }),
                  ),
                }
              : undefined,
          }),
        ),
      }
    : undefined,
  carRental: benefit.carRental
    ? {
        carCategories: benefit.carRental.carCategories.map((category) => ({
          maxCapacity: category.maxCapacity ?? undefined,
          pricings: category.pricings.map((pricing) => ({
            ...pricing,
            periods: pricing.periods.map((period) => ({
              ...period,
              startDate: new Date(period.startDate),
              endDate: new Date(period.endDate),
            })),
          })),
        })),
      }
    : undefined,
  activity: benefit.activity
    ? {
        activityType: benefit.activity.activityType ?? undefined,
        pricingType: benefit.activity.pricingType ?? undefined,
      }
    : undefined,
  VehicleWithChauffeur: benefit.VehicleWithChauffeur
    ? {
        maxCapacity: benefit.VehicleWithChauffeur.maxCapacity ?? undefined,
      }
    : undefined,
  city: benefit.city ?? undefined,
});
